'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'question';
var width = 320;
var height = 512;
var aliases = [10067,10068,61736];
var unicode = '3f';
var svgPathData = ['', 'M48 160c0-53 43-96 96-96l32 0c53 0 96 43 96 96c0 25.2-11.9 48.9-32 64l-89.6 67.2L144 296l0 8 0 48 0 16 32 0 0-16 0-40 83.2-62.4c23.9-17.9 39.4-44.5 43.7-73.6l1.1 0 0-16c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160l32 0zM184 424l-48 0 0 48 48 0 0-48z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faQuestion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;